import React from 'react';
import GraphicLineEditor, { GraphicLineEditorProps } from './graphic-line-editor';
import * as Graphic from '@src/slide/infrastructure/module/independent/graphic';

const WRAPPER_LENGTH = 48;
const CONTAINER_LENGTH = 16;
const BORDER_LENGTH = 14;
const INNER_LENGTH = 10;

interface GraphicLineEditorMobileProps extends GraphicLineEditorProps {
    isConnecting?: boolean;
}

export default class GraphicLineEditorMobile extends GraphicLineEditor<GraphicLineEditorMobileProps> {
    public constructor(props, context) {
        super(props, context);
    }

    public render() {
        return (
            <React.Fragment>
                {
                    this.renderControlPoints(this.props.model.width, this.props.model.height)
                }
            </React.Fragment>
        );
    }
    protected renderControlPoint = (point, index) => {
        const { scale } = this.props;
        const diameter = WRAPPER_LENGTH;
        const innerDiameter = CONTAINER_LENGTH;
        const innerDiameterBack = BORDER_LENGTH;
        const innerInnerDiameter = INNER_LENGTH;
        return (
            <div
                key={index}
                onMouseDown={this.handleControlPointMouseDown.bind(this, index)}
                onTouchStart={this.handleControlPointMouseDown.bind(this, index)}
                style={{
                    width: diameter,
                    height: diameter,
                    left: (point.x * scale) - (diameter / 2),
                    top: (point.y * scale) - (diameter / 2),
                    position: 'absolute',
                    zIndex: 1000,
                    display: this.props.isConnecting ? 'none' : 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    pointerEvents: 'auto',
                }}
            >
                <div
                    style={{
                        width: innerDiameter,
                        height: innerDiameter,
                        border: `${1}px solid rgba(0, 0, 0, 0.12)`,
                        borderRadius: '50%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <div style={{
                        width: innerDiameterBack,
                        height: innerDiameterBack,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        backgroundColor: 'white',
                        borderRadius: '50%',
                    }}>
                        <div
                            style={{
                                width: innerInnerDiameter,
                                height: innerInnerDiameter,
                                borderRadius: '50%',
                                backgroundColor: '#FFAB00',
                            }}
                        />
                    </div>
                </div>
            </div>
        );
    };

    protected handleControlPointMouseDown = (index, e) => {
        e.stopPropagation();
        e.preventDefault();
        this.context.editingStateManager.isControlValuesChanging = true;
        this.startPos = this.getRelativePosByEvent(e);// 真实坐标相对于PPT比例
        this.changeControlPointIndex = index;
        let controlPoint = this.controlPoints[index];
        // 点中的点相的真实坐标，只不过是相对于矩形框的左上角
        if (this.props?.model?.flipH === 1) {
            controlPoint = Graphic.afterFlipH(controlPoint, this.props.model.width / 2);
        }
        if (this.props?.model?.flipV === 1) {
            controlPoint = Graphic.afterFlipV(controlPoint, this.props.model.height / 2);
        }
        if (this.props?.model?.rotate) {
            const centerX = this.props.model.width / 2;
            const centerY = this.props.model.height / 2;
            controlPoint = Graphic.afterRotate(controlPoint, this.props.model.rotate, centerX, centerY);
        }
        this.leftInClient = this.startPos.x - controlPoint.x;
        this.topInClient = this.startPos.y - controlPoint.y;
        document.body.addEventListener('mousemove', this.handleControlPointMouseMove);
        document.body.addEventListener('mouseup', this.handleControlPointChangeEnd);
        document.body.addEventListener('touchmove', this.handleControlPointMouseMove, { passive: false });
        document.body.addEventListener('touchend', this.handleControlPointChangeEnd);
    };

    protected handleControlPointChangeEnd = (e) => {
        e.stopPropagation();
        e.preventDefault();
        document.body.removeEventListener('mousemove', this.handleControlPointMouseMove);
        document.body.removeEventListener('mouseup', this.handleControlPointChangeEnd);
        document.body.removeEventListener('touchmove', this.handleControlPointMouseMove);
        document.body.removeEventListener('touchend', this.handleControlPointChangeEnd);
        if (this.props.onControlValueChange) {
            this.props.onControlValueChange(this.lineInfo.controlValues);
        }
        this.context.editingStateManager.isControlValuesChanging = false;
    };
}
